/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { ConfigState, LogoType, ProductState, StraussLogoType } from './interfaces';
import {
    CONFIG_SET_CODE, CONFIG_GET_RECEIVE, CONFIG_STORE_RECEIVE, CONFIG_CLEAR, CONFIG_SET_BASECOLOR, CONFIG_SET_CONTRASTCOLOR, CONFIG_SET_STRAUSSLOGO, CONFIG_UPDATE_PRODUCT, CONFIG_ADD_PRODUCT, CONFIG_REMOVE_PRODUCT, CONFIG_SET_BASICS, CONFIG_STORE_LOGO_RECEIVE, CONFIG_SET_LOGOTYPE, CONFIG_DELETE_LOGO_RECEIVE, CONFIG_SET_INSPECT_COLOR, CONFIG_SET_INSPECT_SIZE
} from './actions';

export const initialState : ConfigState = {
    code: null,
    baseColorId: '08',
    contrastColorId: '14',
    straussLogo: StraussLogoType.Standard,
    logoFiles: [],
    products: [],
    addBasics: false,
    inspectColor: false,
    inspectSize: false
};
  
function products(state: ProductState[] = [], action : any) : ProductState[] {
    switch (action.type) {
        case CONFIG_UPDATE_PRODUCT: 
            return state.map((entry, index) => {
                if (index === action.index) {
                    return Object.assign({}, entry, action.state);
                }
                return entry;
            });
        case CONFIG_ADD_PRODUCT:
            const existingProduct = state.find((product) => { return product.article === action.name});
            if(existingProduct !== undefined) {
                const newProduct = Object.assign({}, existingProduct);
                if(newProduct.order.findIndex((order) => {return order.size === action.size}) === -1) {
                    newProduct.order.push({
                        amount: 1,
                        size: action.size
                    })
                }

                return state.map((entry, index) => {
                    if (entry.article === newProduct.article) {
                        return Object.assign({}, entry, newProduct);
                    }
                    return entry;
                });
            }

            const newState = [...state];
            newState.push({
                article: action.name,
                order: [ 
                    {
                        amount: 1,
                        size: action.size
                    }
                ],
                logos: []
            });
            return newState;
        case CONFIG_REMOVE_PRODUCT:
            return state.filter((entry, index) => {
                if (index === action.index) {
                    return false;
                }

                return true;
            });
        default:
            return state;
    }
}
  

export default function config(state: ConfigState = initialState, action : any) : ConfigState {
    switch (action.type) {
        case CONFIG_CLEAR:
            return Object.assign({}, state, initialState)
        case CONFIG_GET_RECEIVE:
            return Object.assign({}, state, action.config)
        case CONFIG_STORE_RECEIVE:
            return Object.assign({}, state, {
                code: action.code === null ? state.code : action.code
            })   
        case CONFIG_SET_CODE:
            return Object.assign({}, state, {
                code: action.code
            })
        case CONFIG_SET_BASECOLOR:
            return Object.assign({}, state, {
                baseColorId: action.colorId
            })
        case CONFIG_SET_CONTRASTCOLOR:
            return Object.assign({}, state, {
                contrastColorId: action.colorId
            })
        case CONFIG_SET_STRAUSSLOGO:
            return Object.assign({}, state, {
                straussLogo: action.logo
            })
        case CONFIG_SET_BASICS:
            return Object.assign({}, state, {
                addBasics: action.basics
            })
        case CONFIG_SET_INSPECT_COLOR:
            return Object.assign({}, state, {
                inspectColor: action.inspectColor
            })
        case CONFIG_SET_INSPECT_SIZE:
            return Object.assign({}, state, {
                inspectSize: action.inspectSize
            })
        case CONFIG_ADD_PRODUCT: 
        case CONFIG_UPDATE_PRODUCT: 
        case CONFIG_REMOVE_PRODUCT: 
            return Object.assign({}, state, {
                products: products(state.products, action)
            })
        case CONFIG_STORE_LOGO_RECEIVE:
        case CONFIG_DELETE_LOGO_RECEIVE:
            return Object.assign({}, state, action.config)
        default:
            return state;
    }
}
  
